<template>
  <div class="OrientationSelect mx-2">
    <div v-for="orient in orientations" class="flex mt-2">
      <label
        :for="labelName(orient)"
        :class="isSelected(orient) && 'active'"
        class="OrientationSelect_label capitalize font-normal my-2 flex items-center"
      >
        <input
          class="offscreen"
          type="checkbox"
          :id="labelName(orient)"
          :value="orient"
          @change="toggleCheckbox"
          :name="orient"
          :checked="isSelected(orient)"
        />

        <span class="inline-block mr-2 fa-layers fa-2x">
          <i class="fal fa-square unchecked"></i>
          <i class="fal fa-check-square checked"></i>
        </span>

        {{ orient }}
      </label>

      <span class="ml-auto flex items-center" style="width: 41px; height: 40px" v-if="orient == 'landscape'">
        <img src="@/assets/icons/icon-landscape.svg?inline" style="width: 61px" />
      </span>
      <span class="ml-auto mr-3 flex items-center" v-else-if="orient == 'portrait'">
        <img src="@/assets/icons/icon-portrait.svg?inline" style="width: 25px" />
      </span>
      <span class="ml-auto mr-2 flex items-center" v-else>
        <img src="@/assets/icons/icon-square.svg?inline" style="width: 30px" />
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: "Side.OrientationSelect",
  props: {
    selected: {
      type: Array,
      default: [],
    },
  },
  data() {
    return {
      orientations: ["landscape", "portrait", "square"],
    }
  },
  methods: {
    labelName(label) {
      return `${label}-checkbox`
    },
    capitalize(word) {
      return capitalize(word)
    },
    isSelected(value) {
      return this.selected.includes(value)
    },
    toggleCheckbox(e) {
      const { checked, value } = e.target
      checked ? this.add(value) : this.remove(value)
    },
    add(value) {
      this.$emit("select", { orientations: [...this.selected, value] })
    },
    remove(value) {
      this.$emit("select", { orientations: this.selected.filter((filter) => value != filter) })
    },
  },
}
</script>

<style scoped>
.OrientationSelect_label .checked {
  display: none;
}

.OrientationSelect_label.active .unchecked {
  display: none;
}

.OrientationSelect_label.active .checked {
  @apply text-primary;
  display: inline-block;
}
</style>
